<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <img src="https://upload.wikimedia.org/wikipedia/commons/1/1e/Default-avatar.jpg"
        width="35"
        height="35"
        class="img-avatar"
        alt="" />
    </template>
    <template slot="dropdown">
      <b-dropdown-header tag="div" class="text-center"><strong>Conta</strong></b-dropdown-header>
      <b-dropdown-item v-on:click="meuPerfil"><i class="fa fa-user" /> Meu Perfil</b-dropdown-item>
      <b-dropdown-item @click="modalTrocarSenha = true"><i class="fa fa-key" />Alterar Senha</b-dropdown-item>
      <b-dropdown-divider />
      <b-dropdown-item v-on:click="logout"><i class="fa fa-lock" /> Sair</b-dropdown-item>
      <b-modal title="Alteração de Senha" size="lg" v-model="modalTrocarSenha" ok-title="Salvar" cancel-title="Cancelar"
        no-close-on-backdrop @ok="salvar" @show="zerarModal">
        <b-form-group label="Senha atual:">
          <b-form-input type="password" v-model.trim="atual"/>
        </b-form-group>
        <b-form-group label="Nova senha:">
          <b-form-input type="password" v-model.trim="nova"/>
        </b-form-group>
        <b-form-group label="Confirmar senha:">
          <b-form-input type="password" v-model.trim="confirmacao"/>
        </b-form-group>
      </b-modal>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import Vue from 'vue'
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
import SessionStorage from '@/services/session-storage'
export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown
  },
  created () {
    this.$store.dispatch('getUsuario', SessionStorage.get('usuario'))
  },
  data: () => {
    return {
      itemsCount: 42,
      avatar: SessionStorage.get('avatar'),
      modalTrocarSenha: false,
      atual: null,
      nova: null,
      confirmacao: null
    }
  },
  computed: {
    usuario () {
      return this.$store.state.usuario.usuarioEditar
    }
  },
  methods: {
    logout () {
      sessionStorage.clear()
      this.$router.push('/login')
    },
    meuPerfil () {
      if (this.usuario.tipo === 'S') {
        this.$router.push('/perfil')
      } else {
        this.$router.push('/dados/visualizar/' + this.usuario.sistema_cliente_id)
      }
    },
    salvar (event) {
      if (!this.atual || this.atual.length < 6) {
        this.$bvModal.msgBoxOk('Senha atual inválida. Necessários 6 caracteres, no mínimo', {noCloseOnBackdrop: true})
      } else if (!this.nova || this.nova.length < 6) {
        this.$bvModal.msgBoxOk('Nova senha inválida. Necessários 6 caracteres, no mínimo', {noCloseOnBackdrop: true})
      } else if (!this.confirmacao || this.nova !== this.confirmacao) {
        this.$bvModal.msgBoxOk('Confirmação de senha não é igual a nova senha', {noCloseOnBackdrop: true})
      } else {
        let cpfLimpo = this.usuario.cpf.replace(/[^\d]+/g, '')
        let data = {cpf: cpfLimpo, password: this.atual}

        Vue.http.post('api/auth/authNoCaptcha', data).then(response => {
          if (response.body.msg === 'true') {
            data = {password: this.nova, confirm_password: this.confirmacao, id: this.usuario.id}

            Vue.http.post('api/auth/alterarSenha', data).then(response => {
              if (response.body.success) {
                this.$bvModal.msgBoxOk(response.body.msg, {noCloseOnBackdrop: true})
                this.modalTrocarSenha = false
              } else {
                this.$bvModal.msgBoxOk('Falha na alteração da senha', {noCloseOnBackdrop: true})
              }
            })
          } else {
            this.$bvModal.msgBoxOk('Senha atual não confere', {noCloseOnBackdrop: true})
          }
        })
      }
      event.preventDefault()
    },
    zerarModal (event) {
      this.atual = null
      this.nova = null
      this.confirmacao = null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/templates/containers/DefaultHeaderDropdownAccnt.vue